module.exports = __webpack_public_path__ + "media/customizations/woodforest/logo-4b5822f1a0b04df67a5234968bb37348.png";